// [{},{},{}] = Single Array Multie Object
export const setStateSAMO = (setState, index, key, value) => {
    setState(prev => prev.map((item, i) =>
        i === index ? { ...item, [key]: value } : item
    ));
}

// {} = Single Object
export const setStateSO = (setState, key, value) => {
    setState(prev => ({ ...prev, [key]: value }));
}

// invalid check
export const stateInvalidCheck = (state, keys = []) => {
    // 일반 값 (string, number 등)
    if (keys.length === 0) {
        return state === null || state === undefined || String(state).trim() === '';
    }
    // 객체
    return keys.some(key => {
        const value = state[key];
        return value === null || value === undefined || String(value).trim() === '';
    });
};